import axios from "axios";
import {
    API_COMMENTS_get_commentsProfileUser_rasdel, API_COMMENTS_commentsProfileUser_add_new_coment_for_id_rasdel, API_COMMENTS_judgement_get_for_rasdel,
    API_COMMENTS_judgement_put_for_rasdel, API_COMMENTS_CommentsLectors_add_new_coment_for_id_rasdel, API_COMMENTS_CommentsLectors_get_all_rasdel, API_COMMENTS_judgement_post_new_for_rasdel,
    API_COMMENTS_commentsFeedback_get_all_rasdel, API_COMMENTS_commentsFeedback_add_new_coment_for_id_rasdel, API_COMMENTS_commentsNote_add_new_coment_for_id_rasdel, API_COMMENTS_commentsNote_get_all_rasdel,
    API_COMMENTS_commentsHelp_get_all_rasdel, API_COMMENTS_commentsHelp_add_new_coment_for_id_rasdel, API_COMMENTS_commentsHelp_get_all_comments_admin, API_COMMENTS_commentsHelp_delete_comment_for_id_admin


} from './API';
import { jwtDecode } from 'jwt-decode';
import logger from '../utils/logger';
export default class CommentsService {
    // получить комментарии юзера в своем личном кабинете
    static async getUserCommentsMy() {
        const responce = await axios.get(API_COMMENTS_get_commentsProfileUser_rasdel + jwtDecode(localStorage.getItem('Authorization')).id.toString(), {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return responce.data.data
    }

    // получить оценку своего профиля в комментах
    static async getJudgementToUserIdMy() {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + jwtDecode(localStorage.getItem('Authorization')).id.toString() + '/ProfileUser', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // Новый окмментарий в профиле юзера
    static async postNewCommentProfileUser(idRasdel, textComent) {
        try {
            const response = await axios.post(API_COMMENTS_commentsProfileUser_add_new_coment_for_id_rasdel, { // 
                'idRasdel': idRasdel,
                'textComent': textComent
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // Новый окмментарий в отзывах
    static async postNewCommentFeedback(textComent) {
        try {
            const response = await axios.post(API_COMMENTS_commentsFeedback_add_new_coment_for_id_rasdel, { // 
                'idRasdel': 1,
                'textComent': textComent
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // изменить оценку профиля
    static async putJudgementProfile(idRasdel, change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': idRasdel,
            'rasdel': 'ProfileUser',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }


    // Добавить новый комментарий по id раздела лекции
    static async postNewCommentLecture(idRasdel, textComent) {
        try {
            const response = await axios.post(API_COMMENTS_CommentsLectors_add_new_coment_for_id_rasdel, { // 
                'idRasdel': idRasdel,
                'textComent': textComent
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // Получить все комментарии по одному разделу  id раздела Лекции
    static async getLectureComments(idLecture) {
        const responce = await axios.get(API_COMMENTS_CommentsLectors_get_all_rasdel + idLecture, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return responce.data.data
    }

    // Получить все комментарии по одному разделу  id раздела Юзера
    static async getUserComments(id) {
        const responce = await axios.get(API_COMMENTS_get_commentsProfileUser_rasdel + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return responce.data.data
    }

    // Получить все комментарии по разделу отзывов
    static async getFeadBackComments() {
        const responce = await axios.get(API_COMMENTS_commentsFeedback_get_all_rasdel + '1', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return responce.data.data
    }

    // Создать оценку для нового раздела
    static async postNewRasdelLecture(idRasdel) {
        try {
            const response = await axios.post(API_COMMENTS_judgement_post_new_for_rasdel, { // 
                'idRasdel': idRasdel,
                'rasdel': 'lecture',
                "judgement": 0
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // получить оценку лекции по id лекции
    static async getJudgementToLectureId(idLecture) {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + idLecture + '/lecture', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // получить оценку юзера по id юзера
    static async getJudgementToUserId(id) {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + id + '/ProfileUser', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // получить оценку в отзывах
    static async getJudgementToFeadBack() {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + '1' + '/Feedback', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // изменить оценку лекции
    static async putJudgementLecture(idRasdel, change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': idRasdel,
            'rasdel': 'lecture',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }

    // изменить оценку профиля
    static async putJudgementUser(id, change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': id,
            'rasdel': 'ProfileUser',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }

    // изменить оценку в отзывах
    static async putJudgementFeedback(change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': 1,
            'rasdel': 'Feedback',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }


    //------------------------------------ Статьи и Новости --------------------------------------------------------------

    // Добавить новый комментарий в Новость
    static async postNewCommentNotes(idRasdel, textComent) {
        try {
            const response = await axios.post(API_COMMENTS_commentsNote_add_new_coment_for_id_rasdel, { // 
                'idRasdel': idRasdel,
                'textComent': textComent
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // Получить все комментарии по одному разделу  id раздела Новости
    static async geеNotesComments(id) {
        const responce = await axios.get(API_COMMENTS_commentsNote_get_all_rasdel + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return responce.data.data
    }

    // получить оценку новости по id юзера
    static async getJudgementToNotesId(id) {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + id + '/Notes', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // изменить оценку новости
    static async putJudgementNotes(id, change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': id,
            'rasdel': 'Notes',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }

    // Создать оценку для нового раздела Новости
    static async postNewRasdelNotes(idRasdel) {
        try {
            const response = await axios.post(API_COMMENTS_judgement_post_new_for_rasdel, { // 
                'idRasdel': idRasdel,
                'rasdel': 'Notes',
                "judgement": 0
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    //-------------------------------------HELP------------------------------------------

    // Добавить новый комментарий в хелп
    static async postNewCommentHelp(idRasdel, textComent) {
        try {
            const response = await axios.post(API_COMMENTS_commentsHelp_add_new_coment_for_id_rasdel, { // 
                'idRasdel': idRasdel,
                'textComent': textComent
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
        }
    }

    // Получить все комментарии по одному разделу  id раздела хелп
    static async geеHelpComments(id) {
        const responce = await axios.get(API_COMMENTS_commentsHelp_get_all_rasdel + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return responce.data.data
    }

    // получить оценку хэлпа по id юзера
    static async getJudgementToHelpId(id) {

        const response = await axios.get(API_COMMENTS_judgement_get_for_rasdel + id + '/help', {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.judgement
    }

    // изменить оценку хэлпа
    static async putJudgementHelp(id, change) {
        const response = await axios.put(API_COMMENTS_judgement_put_for_rasdel, { // 
            'idRasdel': id,
            'rasdel': 'help',
            "change": change
        }, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        });
        // return response
        logger.log(response.data);

        return response.data.message
    }

    // Создать оценку для нового раздела хэлпа
    static async postNewRasdelHelp(idRasdel) {
        try {
            const response = await axios.post(API_COMMENTS_judgement_post_new_for_rasdel, { // 
                'idRasdel': idRasdel,
                'rasdel': 'help',
                "judgement": 0
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data.message
        }
        catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
}
    }



}
